import { useMutation } from '@tanstack/react-query'
import { updateBlockConnector } from './requests/update'
import {
  BlockConnectorResponseDocument,
  UpdateBlockConnectorRequestBody,
} from './types'

export type BlockConnectorUpdateParams = {
  id: string
  rowIndex?: number
  yScale?: number
  categoryId?: string | null
  /** Used for updating the query cache for the affected block. */
  blockId?: string
}

type QueryParams = {
  onMutate?: (params: BlockConnectorUpdateParams) => void
  onSuccess?: (
    data: BlockConnectorResponseDocument,
    params: BlockConnectorUpdateParams
  ) => void
}

function buildRequestBody({
  id,
  rowIndex,
  yScale,
  categoryId,
}: BlockConnectorUpdateParams): UpdateBlockConnectorRequestBody {
  return {
    data: {
      id: id,
      type: 'block_connector',
      attributes: {
        ...(rowIndex && { row_index: rowIndex }),
        ...(yScale && { y_scale: yScale }),
      },
      relationships: {
        ...(categoryId !== undefined && {
          category: {
            data: categoryId ? { id: categoryId, type: 'category' } : null,
          },
        }),
      },
    },
  }
}

export const useUpdateBlockConnector = ({
  onMutate,
  onSuccess,
}: QueryParams) => {
  return useMutation({
    mutationFn: (params: BlockConnectorUpdateParams) =>
      updateBlockConnector({
        params: {
          path: { block_connector_id: params.id },
          query: {},
        },
        requestBody: buildRequestBody(params),
      }),
    onMutate,
    onSuccess,
  })
}
